import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { EventPayrollTab } from "../../../../components/Events/Event/Payroll";
import { companyPermissionModules } from "../../../../utils/Constants";
import {
  canAddCompanyModule,
  canEditCompanyModule,
  canViewCompanyModules,
} from "../../../../utils/Permissions";

const CompanyEventPayrollTab = ({ event, onNestedViewChange, onRefreshEvent }) => {
  const login = useSelector((state) => state.auth.login);
  const canView = canViewCompanyModules(
    companyPermissionModules.payroll,
    login,
  );
  const canAdd = canAddCompanyModule(companyPermissionModules.payroll, login);
  const canEdit = canEditCompanyModule(companyPermissionModules.payroll, login);

  if (!canView) {
    return null;
  }

  return (
    <EventPayrollTab
      event={event}
      className="company-event-payroll-tab"
      canAdd={canAdd}
      canEdit={canEdit}
      portal="company"
      onNestedViewChange={onNestedViewChange}
      onRefreshEvent={onRefreshEvent}
      companyLogoUrl={login?.company?.image_url || undefined}
    />
  );
};

CompanyEventPayrollTab.propTypes = {
  event: PropTypes.object,
  onNestedViewChange: PropTypes.func,
  onRefreshEvent: PropTypes.func,
};

CompanyEventPayrollTab.defaultProps = {
  event: null,
  onNestedViewChange: undefined,
  onRefreshEvent: undefined,
};

export default CompanyEventPayrollTab;
